"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const StyledDisclaimer = /*#__PURE__*/_styledComponents.default.p.withConfig({
  displayName: "Disclaimer__StyledDisclaimer",
  componentId: "components-web__sc-1l4xf7u-0"
})(_ref => {
  let {
    fontName,
    fontWeight,
    fontSize,
    ...tokens
  } = _ref;
  const {
    fontFamily
  } = (0, _componentsBase.applyTextStyles)({
    fontName,
    fontWeight
  });
  return {
    fontSize: `${fontSize}px`,
    fontFamily,
    ...tokens
  };
});

/**
 * Use Disclaimer to display singular legal statement and must be displayed
 * immediately adjacent to the related, originating content.
 */
const Disclaimer = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    children,
    ...rest
  } = _ref2;
  const themeTokens = (0, _componentsBase.useThemeTokens)('Disclaimer');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDisclaimer, {
    ref: ref,
    ...selectProps(rest),
    ...themeTokens,
    children: children
  });
});
Disclaimer.displayName = 'Disclaimer';
Disclaimer.propTypes = {
  ...selectedSystemPropTypes,
  tokens: (0, _componentsBase.getTokensPropType)('Disclaimer'),
  children: _propTypes.default.node.isRequired
};
var _default = exports.default = Disclaimer;